import React, { useState } from 'react';
import axios from 'axios';
import './Settings.css';

function Settings({ userId, onClose, updateProfile }) {
    const [formData, setFormData] = useState({
        username: '',
        profilePhoto: null,
        teams: '',
        media: ''
    });

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'profilePhoto') {
            setFormData({
                ...formData,
                profilePhoto: files[0]
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        const form = new FormData();
        form.append('username', formData.username);
        form.append('profilePhoto', formData.profilePhoto);
        form.append('teams', formData.teams);
        form.append('media', formData.media);

        try {
            const response = await axios.put(`http://localhost:3001/api/users/${userId}`, form, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            updateProfile(response.data);
            onClose(); // Close the settings modal after saving changes
        } catch (error) {
            console.error('Error updating profile:', error);
        }
    };

    return (
        <div className="settings-container">
            <div className="settings-content">
                <h2>Edit Profile</h2>
                <form onSubmit={handleSubmit}>
                    <label>
                        Username:
                        <input
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            required
                        />
                    </label>
                    <label>
                        Profile Photo:
                        <input
                            type="file"
                            name="profilePhoto"
                            onChange={handleChange}
                        />
                    </label>
                    <label>
                        Teams:
                        <input
                            type="text"
                            name="teams"
                            value={formData.teams}
                            onChange={handleChange}
                        />
                    </label>
                    <label>
                        Media:
                        <input
                            type="text"
                            name="media"
                            value={formData.media}
                            onChange={handleChange}
                        />
                    </label>
                    <button type="submit">Save Changes</button>
                    <button type="button" onClick={onClose}>Cancel</button>
                </form>
            </div>
        </div>
    );
}

export default Settings;
